import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

type ContextProps = {
  groupNames: string[];
};

export const DrawControllerActiveLayersContext: React.FC<ContextProps> = ({ groupNames }) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginLeft: '5px' }}>
      {groupNames.length > 0 && (
        <div className="leaflet-control-scale-line leaflet-control-scale-line-header" style={{ width: 'fit-content' }}>
          {t('hymotsc.drawTool.activeLayers')}
        </div>
      )}
      {groupNames.map((name, index) => (
        <div key={index} className="leaflet-control-scale-line" style={{ width: 'fit-content' }}>
          {name}
        </div>
      ))}
    </div>
  );
};

export class DrawControllerActiveLayers extends L.Control {
  element: HTMLElement | null;

  constructor(options: L.ControlOptions) {
    super(options);

    this.element = null;
  }

  onAdd = (map: L.Map) => {
    this.element = L.DomUtil.create('div', 'leaflet-control-scale leaflet-control-active-layers');
    return this.element;
  };

  updateContext = (groupNames: string[]) => {
    if (this.element) {
      ReactDOM.render(<DrawControllerActiveLayersContext groupNames={groupNames} />, this.element);
    }
  };

  // eslint-disable-next-line class-methods-use-this
  onRemove = () => {};
}
